
import {createSlice} from '@reduxjs/toolkit'
import { fetchtabdata } from '../../action/master/tabdataAction'

interface tabdataState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: tabdataState = {
  data: null,
  status: 'idle',
  error: null,
}

const tabdataSlice = createSlice({
  name: 'tabdata',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchtabdata.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchtabdata.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchtabdata.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default tabdataSlice.reducer
